import { render, staticRenderFns } from "./etc.vue?vue&type=template&id=08590624&scoped=true&"
import script from "./etc.vue?vue&type=script&lang=js&"
export * from "./etc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08590624",
  null
  
)

export default component.exports